import React from "react";
export const Photo4Shape = ({ image }) => {
  return (
    <svg 
      width="100%" 
      height="100%" 
      viewBox="0 0 214 406" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <defs>
        <linearGradient id="photo4Gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="100%" stopColor="#721F8F" />
        </linearGradient>
        
        <clipPath id="photo4Clip">
          <rect width="213.653" height="405.702" rx="106.827" />
        </clipPath>
      </defs>
      
      <rect 
        width="213.653" 
        height="405.702" 
        rx="106.827" 
        fill="url(#photo4Gradient)"
      />
      
      <image
        href={image}
        x="0"
        y="0"
        width="214"
        height="406"
        clipPath="url(#photo4Clip)"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  );
};
export default Photo4Shape;